module.exports = __webpack_public_path__ + "img/MS.672d771e.svg";